// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Home_mainWrapper__XEUUm","logoutWrapper":"Home_logoutWrapper__N7Xm0"};